import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import { Message } from "element-ui";
import { beforeUpload, productNameValidator } from "./utils";
import Uploader from "@/components/Uploader/index.vue";
export default defineComponent({
    components: {
        Uploader: Uploader
    },
    props: {
        item: {
            type: definePropType(Object),
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    },
    setup: function setup(props) {
        var successUpload = function(response) {
            if (response.code === 0) {
                // eslint-disable-next-line vue/no-mutating-props
                props.item.app_icon = response.data.url;
            } else {
                Message.error(response.msg);
            }
        };
        return {
            beforeUpload: beforeUpload,
            successUpload: successUpload,
            productNameValidator: productNameValidator
        };
    }
});
